<template>
  <div id="app" @mouseover="loginWorker">
    <el-header id="head">
      <head-nav :msgFather="isLogout"></head-nav>
    </el-header>
    <router-view></router-view>
    <el-footer id="footer" v-if="$route.path === '/' || $route.path === '/remoteSenseProduct' || $route.path === '/remoteSenseData' || $route.path === '/subscriptionData'">
      <MainFooter></MainFooter>
    </el-footer>
    <div id="footer" v-else>
      <accountfooter></accountfooter>
    </div>
  </div>
</template>

<script>
import HeadNav from './components/HeadNav'
import accountfooter from './components/accountfooter'
import MainFooter from './components/MainFooter'
export default {
  name: 'App',
  components: {
    HeadNav,
    accountfooter,
    MainFooter
  },
  data() {
    return {
      isLogout: false
    }
  },
  methods: {
    loginWorker() {
      let currentTime = this.currentTime
      let lastTime = new Date().getTime()
      let timeOut = 30 * 60 * 1000
      if (lastTime - currentTime > timeOut) {
        // 未操作页面，跳转登录页面
        this.isLogout = true
      }
      this.currentTime = new Date().getTime()
    }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
* {
  margin: 0;
  padding: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
#app {
  height: 100%;
}
.el-header {
  background-color: #191b2e;
  color: #333;
  text-align: center;
  line-height: 60px;
  position: relative;
  z-index: 9;
  width: 100%;
}
.el-footer i {
  margin-left: 30px;
  font-size: 20px;
  margin-top: 5px;
  color: rgb(28, 203, 150);
}
.el-footer {
  background-color: #191b2e;
  color: #333;
  text-align: center;
  position: relative;
  z-index: 9;
  width: 100%;
  bottom: 0px;
}
.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  padding: 0 0;
  height: 100%;
}
.el-header {
  padding: 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue